import React from 'react';

import { Checkbox, Form } from 'antd';

import { CheckboxGroup } from 'common/components/input';
import DownloadFolderSettingCollapse from './DownloadFolderSettingCollapse';
import { useDownloadProductConfigs } from 'hooks';

import {
  DOWNLOAD_FOLDER_PRODUCT_HIERARCHY,
  DOWNLOAD_FOLDER_PRODUCT_CONFIGS,
} from '../../constants';

const DownloadFolderHierarchySetting = () => {
  const { productConfigsStatus, onCheckHierarchyLevel, onCheckImageType } =
    useDownloadProductConfigs();

  return (
    <DownloadFolderSettingCollapse
      items={Object.keys(DOWNLOAD_FOLDER_PRODUCT_HIERARCHY)}
    >
      {(hierarchyLevel) => {
        const hierarchyImageTypes =
          DOWNLOAD_FOLDER_PRODUCT_HIERARCHY[hierarchyLevel];
        const status = productConfigsStatus[hierarchyLevel];

        return (
          // <DownloadFolderSettingCollapse.Panel
          //   key={hierarchyLevel}
          //   item={hierarchyLevel}
          //   strong
          //   status={status}
          //   onCheck={onCheckHierarchyLevel}
          // >
            <DownloadFolderSettingCollapse items={hierarchyImageTypes}>
              {(imageType) => {
                const status = productConfigsStatus[imageType];

                return (
                  <DownloadFolderSettingCollapse.Panel
                    key={imageType}
                    item={imageType}
                    status={status}
                    style={{ paddingLeft: 20 }}
                    onCheck={onCheckImageType}
                  >
                    <Form.Item name={imageType} noStyle>
                      <CheckboxGroup
                        column={2}
                        options={DOWNLOAD_FOLDER_PRODUCT_CONFIGS[imageType]}
                        style={{ paddingLeft: 20 }}
                        renderItem={(option) => (
                          <Checkbox value={option}>{option}</Checkbox>
                        )}
                      />
                    </Form.Item>
                  </DownloadFolderSettingCollapse.Panel>
                );
              }}
            </DownloadFolderSettingCollapse>
          // </DownloadFolderSettingCollapse.Panel>
        );
      }}
    </DownloadFolderSettingCollapse>
  );
};

export default DownloadFolderHierarchySetting;
